import { Box, Button, Link, Paper, TableCell, TableRow, Typography } from '@material-ui/core'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import PropTypes from 'prop-types'
import { ArrowLeft, Hash } from 'react-feather'
import { useTranslation } from 'react-i18next'

import ExcelLogo from '../../../../assets/images/learnstage-logo.png'
import { ROUTES } from '../../../../helpers/constants'
import { getFullName } from '../../../../helpers/utils'
import withRedirect from '../../../../hocs/RedirectHOC'
import CustomTable from '../../../table/CustomTable'
import ProgramReviewPost from '../allEnrollments/programDetails/ProgramReviewPost'

function CourseCompleted({
  allHeadCells,
  toggleReviewPopup,
  openReviewPopup,
  coursesCompletedList,
  rateReviewCourse,
  courseReviewSetting,
}) {
  const { t } = useTranslation()
  const dataParameter = 'id'
  const ButtonEnhanced = withRedirect(Button)

  return (
    <>
      <Box
        py={2}
        px={3}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <Box className="brand-logo">
          <img
            src={coursesCompletedList.sch_logo || ExcelLogo}
            alt="Logo"
            onError={(e) => {
              e.target.onerror = null
              e.target.src = ExcelLogo
            }}
          />
        </Box>
        <Box display="flex" alignItems="center" mt={{ xs: 1, sm: 0 }}>
          <ButtonEnhanced
            className="custom-default-button text-transform-none"
            variant="contained"
            disableElevation
            to={ROUTES.LOGIN}
            startIcon={<ArrowLeft width={16} height={16} />}
          >
            {t('back')}
          </ButtonEnhanced>
        </Box>
      </Box>
      <Box p={2}>
        <Box mt={1} mb={2}>
          <Typography component="h6" variant="body2" tabIndex={0}>
            <Box component="span" fontSize={'18px'} fontWeight={600}>
              {t('shareYourHonestLearningExperience')}
            </Box>
          </Typography>
        </Box>
        <Box p={2} className="program-welcome-bar" display={'flex'} flexDirection={'row'}>
          <Box display={'flex'} alignItems={'center'}>
            <Typography component="h6" variant="subtitle1" tabIndex={0}>
              <Box fontSize={'14px'} component="span" fontWeight={600}>
                {t('name') + ':'}
              </Box>
            </Typography>
            <Typography component="h6" variant="subtitle1" tabIndex={0}>
              <Box ml={1} fontSize={'14px'} component="span" fontWeight={600}>
                {getFullName(coursesCompletedList)}
              </Box>
            </Typography>
            <Box ml={2} color={'var(--color-silver-dopely)'}>
              <FiberManualRecordIcon style={{ width: '8px', height: '8px' }} />
            </Box>
          </Box>

          <Box ml={2} display={'flex'} alignItems={'center'}>
            <Box mr={1} display={'flex'} color={'var(--color-blue-light)'}>
              <Hash width={18} height={18} />
            </Box>
            <Typography component="h6" variant="subtitle1" tabIndex={0}>
              <Box fontSize={'14px'} component="span" fontWeight={600}>
                {t('studentID') + ':'}
              </Box>
            </Typography>
            <Typography component="h6" variant="subtitle1" tabIndex={0}>
              <Box ml={1} fontSize={'14px'} component="span" fontWeight={600}>
                {coursesCompletedList?.public_id}
              </Box>
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <Typography component="h6" variant="subtitle1" color="textPrimary" tabIndex={0}>
            <Box component="span" fontSize={'18px'} fontWeight={600}>
              {t('coursesCompleted')}
            </Box>
          </Typography>
        </Box>
        <Paper rounded="true" elevation={1} className="paper-round">
          <Box className="cutsom-table-actions">
            <CustomTable
              noDataMessage={t('tableNoRecordFoundMessage')}
              data={coursesCompletedList?.courseRatingListing}
              headCells={allHeadCells}
              dataParameter={dataParameter}
              isSelection={false}
            >
              {coursesCompletedList?.courseRatingListing?.map((row) => {
                return (
                  <TableRow hover data-id={row.id} key={row.id}>
                    <TableCell tabIndex={0}>
                      <Box width="100%" className="block-ellipsis">
                        {row.cr_name}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box>{row.updatedEncTimeLabel}</Box>
                    </TableCell>

                    <TableCell>
                      <Link
                        underline="always"
                        className="see-all-reviews hdt-add-review"
                        color="primary"
                        data-id={row.ticketid}
                        onClick={(e) => {
                          toggleReviewPopup(e, row)
                        }}
                      >
                        {t('rateTicket')}
                      </Link>
                    </TableCell>
                  </TableRow>
                )
              })}
            </CustomTable>
          </Box>
        </Paper>
      </Box>
      <ProgramReviewPost
        open={openReviewPopup}
        onClose={toggleReviewPopup}
        programReviewSettings={courseReviewSetting}
        rateReviewProgram={rateReviewCourse}
      />
    </>
  )
}
CourseCompleted.propTypes = {
  allHeadCells: PropTypes.object,
  toggleReviewPopup: PropTypes.func,
  openReviewPopup: PropTypes.bool,
  coursesCompletedList: PropTypes.array,
  rateReviewCourse: PropTypes.func,
  courseReviewSetting: PropTypes.array,
}

CourseCompleted.defaultProps = {
  allHeadCells: {},
  toggleReviewPopup: () => {},
  openReviewPopup: false,
  coursesCompletedList: [],
  rateReviewCourse: () => {},
  courseReviewSetting: [],
}

export default CourseCompleted
